import { Spinner } from "@chakra-ui/react";
import { Table } from "antd";
import { useEffect } from "react";

const ThemeTable = ({ columns, data, loader, pagination, onRow, scroll }) => {
  useEffect(() => {}, [data]);
  return !data ? (
    <>
      <Spinner />
    </>
  ) : (
    <Table
      className="table-layout"
      onRow={onRow}
      columns={columns}
      dataSource={data}
      pagination={{
        defaultPageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "30"],
        showTotal: (total, range) =>
          `${range[0]}-${range[1]} of ${total} items`,
        total: pagination?.total || data?.length,
        hideOnSinglePage: true,
        onChange: (page, pageSize) => {
          if (pagination) {
            pagination.setCurrentPage(page);
            pagination.setResultPerPage(pageSize);
          }
        },
      }}
      // loading={loader}
      scroll={scroll}
    />
  );
};

export default ThemeTable;
